import type { ContratProADTO } from '@/features/api/extranet/dto/Demande/PROA'
import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
import type { NaturesFichiersDemandeCallback } from '@/features/domaine/regles-akto/shared'

export const getNaturesFichiersProa: NaturesFichiersDemandeCallback<ContratProADTO> = (demande, typeContext) => {
  let obligatoires = ['Cerfa']
  let facultatifs = ['Autre', 'ProtocoleIndividuelFormationFOAD']
  let facultatifsDefaut: string[] = []

  const existsFormationInterne = demande.formation?.modules?.some((x) => x.typeModule === 'Interne')

  const nbModule = demande.formation?.modules?.length ?? 0
  const nbFormationExterne = demande.formation?.modules?.filter((x) => x.typeModule === 'Externe').length ?? 0

  if (nbFormationExterne > 0) obligatoires.push('Convention')

  if (existsFormationInterne) {
    obligatoires.push('Calendrier')
    obligatoires.push('AttestationFormateurInterne')
  }

  if (typeContext === TypesContextesAutorisesEnum.Prestataire) {
    facultatifs = [...obligatoires, ...facultatifs]
    facultatifsDefaut = [...obligatoires, ...facultatifsDefaut]
    obligatoires = []
  }
  return {
    obligatoires: obligatoires,
    facultatifs: facultatifs,
    facultatifsDefaut: facultatifsDefaut,
    /* Si absent, prend valeur par défaut. Peut-etre calculé. Exemple :
        {
            'Cerfa': 10,
            'Convention': 2
        }
    */
    nombreFichiersMaximum: {},
    nombreFichiersMinimum: {
      Convention: nbFormationExterne,
      Programme: nbModule,
    },
  }
}
